import axios from "axios";
import { HttpClient, RequestParams } from "../../utils/api/http-client";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import { IChatQuery, IChatMessageQuery } from "../../models/chat/query";
import { IChatMessage, IChat, IChatMessages } from "../../models/chat/response";
import {IChatMessageRequest, ISendMessage} from "../../models/chat/request";
import { ACCESS_TOKEN, LANGUAGE_CODE } from "../../utils/helpers/constants";
import { ICreateChatResponse } from "../../models/chat/response";
import { ICreateChat } from "../../models/chat/request";

class ChatService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  createChat = (data: ICreateChat, params?: RequestParams) =>
    this.http.request<ICreateChatResponse>({
      path: `/chats/create`,
      method: "POST",
      body: data,
      ...params,
    });

  sendMessage = (data: IChatMessageRequest, params?: RequestParams) => {
    // إنشاء كائن البيانات مع fileId إذا كان موجوداً
    const requestBody = {
      body: data.body,
      chatId: data.chatId,
      isAdmin: data.isAdmin,
      ...(data.fileId && { fileId: data.fileId })
    };
    
    return this.http.request<IChatMessage>({
      path: `/messages`,
      method: "POST",
      body: requestBody,
      ...params,
    });
  };
  getConversations = (query: IChatQuery, params?: RequestParams) =>
    this.http.request<IChat[]>({
      path: `/chats`,
      method: "GET",
      query,
      ...params,
    });

  getMessages = (query: IChatMessageQuery, params?: RequestParams) =>
    this.http.request<IChatMessages>({
      path: `/indexForAdmin`,
      method: "GET",
      query: query,
      ...params,
    });
}

//   deleteConversation = (id: string, params?: RequestParams) =>
//     this.http.request<{ success: boolean }>({
//       path: `/conversations/${id}`,
//       method: "DELETE",
//       ...params,
//     });

//   exportChatHistory = (conversationId: string, query: IChatQuery) =>
//     axios.get(`${process.env.REACT_APP_BASE_API_URL}/conversations/${conversationId}/export`, {
//       headers: {
//         authorization: `Bearer ${
//           localStorage.getItem(ACCESS_TOKEN) ||
//           sessionStorage.getItem(ACCESS_TOKEN)
//         }`,
//         "Content-Type": "application/json",
//         "accept-language": `$${
//           localStorage.getItem(LANGUAGE_CODE) ??
//           process.env.REACT_APP_DEFAULT_LANGUAGE
//         }`,
//       },
//       params: query,
//       responseType: "arraybuffer",
//     });
// }

export default ChatService;
